module.exports = __webpack_public_path__ + "static/media/CCU_Arg-11.ccf7c523.png";